import { Loader } from "@/components/loader";
import { Button, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  getActiveAreaId,
  getInsurerList,
  setPatientInsuranceStatus,
} from "../../../../api/area";
import SearchInput from "../../../project/searchInput";
import TableInsurer from "../../table/tableInsurer";

export default function Insurer() {
  const [patients, setPatients] = useState([]);
  const [valueSearch, setValueSearch] = useState("");
  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalSize, setTotalSize] = useState();
  const [loading, setLoading] = useState(false);
  const [lastFetch, setLastFetch] = useState();
  const [areaId, setAreaId] = useState();

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  const fetchPatients = useCallback(
    (refetchTotalElements, clearSearch) => {
      if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;

      setLoading(true);
      const query = new URLSearchParams();
      query.append("justHasNotInsurance", true);
      query.append("pageIndex", pageable.pageIndex);
      query.append("pageSize", pageable.pageSize);
      if (!clearSearch && valueSearch && valueSearch.length > 1) {
        query.append("search", valueSearch);
      }
      query.append(
        "needTotalElements",
        totalSize === undefined || refetchTotalElements,
      );

      getInsurerList(areaId, `?${query.toString()}`)
        .then((res) => {
          if (res) {
            setLastFetch(Date.now());
            setPatients(res.patients);

            if (refetchTotalElements) {
              setPageable({
                pageIndex: 0,
                pageSize: 10,
              });
            }
            if (totalSize === undefined || refetchTotalElements)
              setTotalSize(res.totalElements);
          }
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    },
    [areaId, pageable, valueSearch],
  );

  useEffect(() => {
    if (areaId) {
      fetchPatients(false, false);
    }
  }, [areaId, pageable]);

  const [timer, setTimer] = useState();
  useEffect(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }

    if (valueSearch.length >= 2) {
      const t = setTimeout(() => {
        fetchPatients(true, false);
      }, 500);

      setTimer(t);
    }

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    };
  }, [valueSearch]);

  return (
    <>
      {loading && <Loader />}
      <Grid display={"flex"} flexDirection={"row"}>
        <SearchInput
          type="text"
          id="filter-text-box-before-train"
          value={valueSearch}
          onChange={(e) => setValueSearch(e.target.value)}
          mb="5px"
        />
        {valueSearch.length >= 2 && (
          <Button
            onClick={() => {
              setValueSearch("");
              fetchPatients(true, true);
            }}
          >
            پاک کردن فیلتر
          </Button>
        )}
      </Grid>

      <TableInsurer
        totalElements={totalSize}
        pageable={pageable}
        setPageable={setPageable}
        rowData={patients}
        handlePatientClick={(patientId) => {
          setPatientInsuranceStatus(areaId, patientId, "?insurance=SALAMAT")
            .then(() => {
              setPatients(
                patients.filter((p) => p.patientInfo.id !== patientId),
              );
            })
            .catch(() => {});
        }}
      />
    </>
  );
}
